import { CommonModule } from '@angular/common';
import {
    TgButtons2Module,
    TgFormsModule,
    TgGridModule,
    TgIconEmoHappyModule,
    TgIconEmoNeutralModule,
    TgIconEmoSadModule,
    TgModalModule,
    TgSpacingModule,
    TgToggleModule
} from '@trademe/tangram';
import { NgModule } from '@angular/core';
import { FeedbackModalComponent } from './feedback-modal.component';

@NgModule({
    imports: [
        CommonModule,
        TgGridModule,
        TgModalModule,
        TgIconEmoHappyModule,
        TgIconEmoNeutralModule,
        TgIconEmoSadModule,
        TgFormsModule,
        TgSpacingModule,
        TgToggleModule,
        TgButtons2Module
    ],
    declarations: [
        FeedbackModalComponent
    ],
    exports: [FeedbackModalComponent]
})
export class FeedbackModule {
}
